/**
 * personelListeDurumu.js — Firma Detay › Personel Listesi'nin durumu ↔ adres çubuğu (#728).
 *
 * Kişi Listesi gibi (kisiListService.listeDurumunuUrleYaz, #262): sekme, alt sekme, arama, sayfa ve sayfa boyutu adreste yaşar; kişi
 * detayından "geri" dönüşte hepsi yerinde durur. Anahtarlar `sekme` / `alt` (bu sayfa onları zaten başlangıç sekmesi için okuyordu),
 * `q`, `sayfa`, `boyut`. Yalnızca varsayılandan farklı olanlar yazılır (aynı durum → aynı dize; gereksiz geçmiş/yenileme olmasın);
 * `tab`, `fuarId`, `profilTab` gibi başka anahtarlara dokunulmaz.
 */
import { PERSONEL_SEKME, PERSONEL_ALT_SEKME } from "../../services/personelRosterService";
import { VARSAYILAN_SAYFA_BOYUTU } from "../Common/sayfaBoyutu";

export const PERSONEL_LISTE_ANAHTARLARI = ["sekme", "alt", "q", "sayfa", "boyut"];

export function listeDurumunuAdreseYaz(searchParams, { sekme, alt, arama, sayfa, boyut }) {
  const next = new URLSearchParams(searchParams);
  PERSONEL_LISTE_ANAHTARLARI.forEach((k) => next.delete(k));
  if (sekme && sekme !== PERSONEL_SEKME.TUM) next.set("sekme", sekme);
  if (alt && alt !== PERSONEL_ALT_SEKME.TUMU) next.set("alt", alt);
  if (arama) next.set("q", arama);
  if (sayfa > 1) next.set("sayfa", String(sayfa));
  if (boyut && boyut !== VARSAYILAN_SAYFA_BOYUTU) next.set("boyut", String(boyut));
  return next;
}
